<section class="fullWidthCls admPageSec marginAtTop">
  <div class="container-fluid">
    <div class="row">
      <div class="admPageTitleSec">
        <p class="admPageTitle">
          <img src="./assets/images/manageExamTitleIcon.png" alt="" />
          <span>Exam Deliveries</span>
        </p>
      </div>
      <md-card>
        <md-card-header>
          <div class="admPageHeadingSec">
            <md-card-title>
              <div class="admPageHeading">
                <p>
                  <span>Search Exam Deliveries</span>
                </p>
              </div>
            </md-card-title>
          </div>
        </md-card-header>
        <md-card-content>
          <form class="example-form" [formGroup]="form">
            <div id="eligibilityFilters">
              <div class="col s12 m12 l12 admSubPageHeading" style="padding-bottom: 1em;">
                <p>Eligibility Options</p>
              </div>
              <div class="col s12 m4 l4">
                <md-select placeholder="Status" formControlName="searchStatusControl">
                  <md-option *ngFor="let option of statusOptions" [value]="option" (click)="examStatusChanged(option.examStatusCode)">
                    {{ option.examStatus }}
                  </md-option>
                </md-select>
              </div>
              <div class="col s12 m4 l4">
                <md-form-field class="example-full-width">
                  <input type="text" placeholder="Eligibility Code" mdInput formControlName="searchEligibilityCodeControl">
                </md-form-field>
              </div>
              <div class="col s12 m4 l4">
                <md-form-field class="example-full-width">
                  <input type="text" placeholder="User Red Hat ID" mdInput formControlName="searchUserRhIdControl">
                </md-form-field>
              </div>
              <div class="col s12 m4 l4">
                <md-form-field class="example-full-width">
                  <input type="text" placeholder="User First/Last Name" mdInput formControlName="searchNameControl" [mdAutocomplete]="searchName">
                  <md-autocomplete #searchName="mdAutocomplete">
                    <md-option *ngFor="let option of nameOptions" [value]="option.showStr">
                      {{ option.showStr }}
                    </md-option>
                  </md-autocomplete>
                </md-form-field>
              </div>
              <div class="col s12 m4 l4">
                <md-form-field class="example-full-width">
                  <input type="text" placeholder="User Email" mdInput formControlName="searchUserEmailControl">
                </md-form-field>
              </div>
            </div>
            <div *ngIf="showExamTypeSearch" class="col s12 m4 l4">
              <md-form-field class="example-full-width">
                <input type="text" placeholder="Exam Type" mdInput formControlName="searchExamTypeControl" [mdAutocomplete]="searchExamType" [showDropDown]="{model: 'examType', scope: this }">
                <md-autocomplete #searchExamType="mdAutocomplete" [displayWith]="_utility.displayFn">
                  <md-option *ngFor="let option of examTypeFilteredOptions | async" [value]="option">
                    {{ option.name }}
                  </md-option>
                </md-autocomplete>
              </md-form-field>
            </div>
            <div id="scheduleFilters" *ngIf="showScheduleSearch">
              <div class="col s12 m12 l12 admSubPageHeading" style="padding-bottom: 1em;">
                <p>Schedule Options</p>
              </div>
              <div class="col s12 m4 l4">
                <md-form-field class="example-full-width">
                  <input type="text" placeholder="Time Zone To Display" mdInput formControlName="searchTimeZoneControl" [mdAutocomplete]="searchTimeZone" [showDropDown]="{model: 'timeZone', scope: this }">
                  <md-autocomplete #searchTimeZone="mdAutocomplete" [displayWith]="_utility.displayFn">
                    <md-option *ngFor="let option of timeZoneFilteredOptions | async" [value]="option">
                      {{ option.name }}
                    </md-option>
                  </md-autocomplete>
                </md-form-field>
              </div>
              <div class="col s12 m4 l4" *ngIf="isGlobalAdmin">
                <md-form-field class="example-full-width">
                  <input type="text" placeholder="Region" mdInput formControlName="searchRegionControl" [mdAutocomplete]="searchRegion" [showDropDown]="{model: 'region', scope: this }">
                  <md-autocomplete #searchRegion="mdAutocomplete" [displayWith]="_utility.displayFn">
                    <md-option *ngFor="let option of regionFilteredOptions | async" [value]="option">
                      {{ option.name }}
                    </md-option>
                  </md-autocomplete>
                </md-form-field>
              </div>
              <div class="col s12 m4 l4">
                <div class="errorZoneSec">
                  <md-form-field class="example-full-width">
                    <input type="text" placeholder="Location Name" mdInput formControlName="searchLocationControl" [mdAutocomplete]="location" [showDropDown]="{model: 'location', scope : this }">
                    <md-autocomplete #location="mdAutocomplete" [displayWith]="_utility.displayFn">
                      <md-option *ngFor="let option of locationFilteredOptions | async" [value]="option" class="subOptionShow">
                        <span>
                          {{ option.name }}
                          <span title="{{ option.locationAddress }}" class="locationListAddressCls">
                            <br/>{{ option.locationAddress }}</span>
                        </span>
                      </md-option>
                    </md-autocomplete>
                  </md-form-field>
                  <p requiredField *ngIf="form.controls.searchLocationControl.touched && (form.controls.searchLocationControl.errors && form.controls.searchLocationControl.errors.required)"></p>
                </div>
              </div>
              <div class="col s12 m12 l12"><p>Effective Date</p></div>
              <div class="col s12 m4 l4  pickCalendarCls">
                <div class="errorZoneSec">
                  <md-form-field class="mng-exam-del-date-spcl-cls">
                    <input mdInput [mdDatepicker]="pickerFrom" placeholder="From" formControlName="searchFromDateControl">
                    <md-datepicker-toggle mdSuffix [for]="pickerFrom"></md-datepicker-toggle>
                    <md-datepicker #pickerFrom></md-datepicker>
                  </md-form-field>
                  <p requiredField *ngIf="form.controls.searchFromDateControl.touched && (form.controls.searchFromDateControl.errors && form.controls.searchFromDateControl.errors.required)"></p>
                  <p class="validate" *ngIf="form.controls.searchFromDateControl.touched && form.controls.searchFromDateControl.errors">Invalid date</p>
                </div>
              </div>
              <div class="col s12 m4 l4  pickCalendarCls">
                <div class="errorZoneSec">
                  <md-form-field class="mng-exam-del-date-spcl-cls">
                    <input mdInput [mdDatepicker]="pickerTo" placeholder="To" formControlName="searchToDateControl" [min]="minDate">
                    <md-datepicker-toggle mdSuffix [for]="pickerTo" ></md-datepicker-toggle>
                    <md-datepicker #pickerTo></md-datepicker>
                  </md-form-field>
                  <p requiredField *ngIf="form.controls.searchToDateControl.touched && (form.controls.searchToDateControl.errors && form.controls.searchToDateControl.errors.required)"></p>
                  <p class="validate" *ngIf="form.controls.searchToDateControl.touched && form.controls.searchToDateControl.errors && form.controls.searchToDateControl.errors.mdDatepickerParse">Invalid date</p>
                  <p class="validate" *ngIf="(form.controls.searchToDateControl.value && form.controls.searchToDateControl.invalid)">
                    To Date can't be less than From date</p>
                </div>
              </div>
            </div>
            <md-card-actions>
              <div class="button-row">
                <button [disabled]="isSearchDisabled || form.invalid" md-raised-button class="glbAdminBtnCls1" (click)="onSearch()">
                  <i class="material-icons">&#xE8B6;</i>SEARCH</button>
                <button [disabled]="isSearchDisabled || form.invalid" md-raised-button class="glbAdminBtnCls1" (click)="downloadCsv()">
                  <i class="material-icons">&#xE2C4;</i>DOWNLOAD CSV</button>
                <button [disabled]="isSearchDisabled || form.invalid" md-raised-button class="glbAdminBtnCls1" (click)="downloadProctorCsv()" *ngIf="isGlobalAdmin || isProctor">
                  <i class="material-icons">&#xE2C4;</i>PROCTOR CSV</button>
              </div>
            </md-card-actions>
            <div class="col s12 m4 l4"><p>(NOTE: This will return max 10000 results)</p></div>
          </form>
        </md-card-content>
      </md-card>

      <div id="exam-delivery-div" class="cusPaginationContainer example-container mat-elevation-z8">
        <div *ngIf="paginationInfo && paginationInfo.totalRecords == 0">
          <p class="nodataFound"> No Results Found</p>
        </div>
        <md-table class="mngLocGridSec" #table [dataSource]="dataSource" mdSort [ngClass]="{'hide-grid': paginationInfo &&paginationInfo.totalRecords <= 0 }">

          <md-header-row *mdHeaderRowDef="displayedColumns"></md-header-row>
          <md-row *mdRowDef="let row; columns: displayedColumns;"></md-row>

          <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

            <!-- Candidate Name Column -->
            <ng-container mdColumnDef="candidateName">
              <md-header-cell *mdHeaderCellDef md-sort-header>CANDIDATE NAME</md-header-cell>
              <md-cell *mdCellDef="let element"> {{element.candidateName}} </md-cell>
            </ng-container>

            <!-- Candidate RhId Column -->
            <ng-container mdColumnDef="userRhId">
              <md-header-cell *mdHeaderCellDef md-sort-header>RED HAT ID</md-header-cell>
              <md-cell *mdCellDef="let element"> {{element.userRhId}}</md-cell>
            </ng-container>

            <!-- Exam code name Column -->
            <ng-container mdColumnDef="examCodeName">
              <md-header-cell *mdHeaderCellDef md-sort-header>EXAM CODE: NAME</md-header-cell>
              <md-cell *mdCellDef="let element"> {{element.examCodeName}} </md-cell>
            </ng-container>

            <!-- Reference Number Column -->
            <ng-container mdColumnDef="eligibilityCode">
              <md-header-cell *mdHeaderCellDef md-sort-header>ELIGIBILITY CODE</md-header-cell>
              <md-cell *mdCellDef="let element"> {{element.eligibilityCode}} </md-cell>
            </ng-container>

            <!-- Location Name Column -->
            <ng-container mdColumnDef="locationName">
              <md-header-cell *mdHeaderCellDef md-sort-header>LOCATION NAME</md-header-cell>
              <md-cell *mdCellDef="let element"> {{element.locationName}} </md-cell>
            </ng-container>

            <!-- Effective date Column -->
            <ng-container mdColumnDef="examStartDateTime">
              <md-header-cell *mdHeaderCellDef md-sort-header>EFFECTIVE DATE</md-header-cell>
              <md-cell *mdCellDef="let element"> {{(element.examStartDateTime | dateTimeFormat : '' : element.timeZone) }} </md-cell>
            </ng-container>

            <!-- STATUS Column -->
            <ng-container mdColumnDef="statusDisplay">
              <md-header-cell *mdHeaderCellDef md-sort-header>STATUS</md-header-cell>
              <md-cell *mdCellDef="let element">{{element.statusDisplay}}</md-cell>
            </ng-container>

            <!-- Contact Number Column -->
            <ng-container mdColumnDef="candidateContactNumber">
              <md-header-cell *mdHeaderCellDef md-sort-header>CONTACT NUMBER</md-header-cell>
              <md-cell *mdCellDef="let element"> {{element.candidateContactNumber}} </md-cell>
            </ng-container>

            <!-- Contact Number Column -->
            <ng-container mdColumnDef="candidateEmail">
              <md-header-cell *mdHeaderCellDef md-sort-header>EMAIL</md-header-cell>
              <md-cell *mdCellDef="let element"> {{element.candidateEmail}} </md-cell>
            </ng-container>

            <!-- Action Column -->
            <ng-container mdColumnDef="actions">
              <md-header-cell *mdHeaderCellDef>ACTIONS</md-header-cell>
              <md-cell *mdCellDef="let el"><a *ngIf="canShowManage(el)" (click)="onManageClick(el)">Manage</a></md-cell>
            </ng-container>
        </md-table>
        <md-paginator [ngClass]="{'hide-grid': paginationInfo && paginationInfo.totalRecords <= 0 }" #paginator [length]="paginationInfo.totalRecords"
          [pageIndex]="0" [pageSize]="dataSource.initialPageSize" [pageSizeOptions]="dataSource.pageSizeOptions">
        </md-paginator>
      </div>
    </div>
  </div>
</section>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-eligibilities/adm-manage-eligibilities.component.html